"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapWithQueryContext = exports.wrapWithABContext = exports.wrapWithAemConfigurationContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const common_components_1 = require("@as-react/common-components");
const react_query_1 = require("@tanstack/react-query");
const wrapWithAemConfigurationContext = (BaseComponent, { aemConfigurationValue }) => function aemConfigurationContextWrapper(props) {
    return ((0, jsx_runtime_1.jsx)(common_components_1.AemConfigurationContextWrapper, { value: aemConfigurationValue, children: (0, jsx_runtime_1.jsx)(BaseComponent, Object.assign({}, props)) }));
};
exports.wrapWithAemConfigurationContext = wrapWithAemConfigurationContext;
const wrapWithABContext = (BaseComponent, { abConfigurationValue }) => function abContextWrapper(props) {
    return ((0, jsx_runtime_1.jsx)(common_components_1.ABContext.Provider, { value: abConfigurationValue, children: (0, jsx_runtime_1.jsx)(BaseComponent, Object.assign({}, props)) }));
};
exports.wrapWithABContext = wrapWithABContext;
const wrapWithQueryContext = (BaseComponent, { dehydratedState }) => function QueryContextWrapper(props) {
    const [client] = React.useState(() => new react_query_1.QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60 * 1000,
                retry: false,
            },
        },
    }));
    return ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, { client: client, children: (0, jsx_runtime_1.jsx)(react_query_1.HydrationBoundary, { state: dehydratedState, children: (0, jsx_runtime_1.jsx)(BaseComponent, Object.assign({}, props)) }) }));
};
exports.wrapWithQueryContext = wrapWithQueryContext;
//# sourceMappingURL=contextWrapper.js.map